import { UserRegistrationRequest } from '@ravago/shared/page-data/models/elements';

export abstract class UserUtils {
  static async checkIfUserExists(email: string) {
    const response = await fetch(`/api/user-by-email/${email}`, {
      method: 'HEAD',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });
    return response.status === 204;
  }

  static async registerUser(userRegistration: UserRegistrationRequest, captchaToken?: string) {
    const response = await fetch(`/api/registration/user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-reCAPTCHA-token': captchaToken || ''
      },
      cache: 'no-cache',
      body: JSON.stringify(userRegistration)
    });

    return response.ok;
  }
}
